import { Box, IconButton, Tooltip } from '@material-ui/core';
import { SButton, SETVIImage } from '@setvi/shared/components';
import { UserIcon } from '@setvi/shared/components/sicons';
import { useRef } from 'react';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { useTooltipStyles } from '../../style';

interface PhotoProps {
  handleChange: (name: string, photo: string, file?: File) => void;
  photo?: string;
  alt?: string;
}

const Photo = ({ handleChange, photo, alt }: PhotoProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const tooltipClasses = useTooltipStyles();

  const handlePhotoUpload = (file: File) => {
    // Convert file to base64 or handle upload as needed
    const reader = new FileReader();
    reader.onloadend = () => {
      handleChange('photo', reader.result as string, file);
    };

    reader.readAsDataURL(file);
  };

  const handleFileInputChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      handlePhotoUpload(file);
    }
  };

  const handleAddPhotoClick = () => {
    fileInputRef.current?.click();
  };

  const handleRemovePhoto = () => {
    handleChange('photo', '');
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleFileInputChange}
      />
      <Box
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          gap: 4
        }}>
        <Box
          style={{
            borderRadius: '50%',
            background: '#1E96FC',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 64,
            height: 64,
            border: '2px solid #EEF0F2',
            position: 'relative'
          }}>
          {!photo ? (
            <UserIcon htmlColor="white" />
          ) : (
            <>
              <Box
                style={{
                  width: '100%',
                  height: '100%',
                  overflow: 'hidden'
                }}>
                <SETVIImage
                  style={{
                    width: '100%',
                    height: '100%'
                  }}
                  fit="cover"
                  radius="50%"
                  src={photo || ''}
                  alt={alt || 'Photo'}
                />
              </Box>
              <Tooltip
                title="Remove photo"
                arrow
                placement="right"
                classes={tooltipClasses}>
                <IconButton
                  onClick={handleRemovePhoto}
                  style={{
                    background: '#20262D',
                    position: 'absolute',
                    padding: 3,
                    margin: 0,
                    top: 3,
                    right: -8
                  }}>
                  <CloseRoundedIcon
                    style={{
                      width: 16,
                      height: 16
                    }}
                    htmlColor="white"
                  />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Box>

        <SButton
          color="default"
          variant="outlined"
          onClick={handleAddPhotoClick}
          style={{
            borderRadius: 120,
            minHeight: 0,
            height: 'auto',
            padding: '2px 12px',
            margin: 0,
            color: '#5D7083',
            fontSize: 12,
            fontWeight: 600,
            borderColor: '#AFBAC6'
          }}>
          {!photo ? 'Add photo' : 'Replace photo'}
        </SButton>
      </Box>
    </>
  );
};

export default Photo;
